import React from 'react';
import { motion } from 'framer-motion';

const FlatteningIllustration = () => {
  return (
    <div className="w-full h-full bg-abyss-900/20 rounded-lg p-4 border border-teal-500/10">
      <svg viewBox="0 0 800 300" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
        <defs>
          <style>
            {`
              .node { fill: #2DD4BF; }
              .node-label { font-family: 'JetBrains Mono', monospace; font-size: 10px; fill: rgba(255,255,255,0.7); }
              .connection { stroke: rgba(45,212,191,0.3); stroke-width: 1; }
              .arrow { fill: #F0705C; }
              .arrow-label { font-family: 'JetBrains Mono', monospace; font-size: 14px; fill: #F0705C; font-weight: 600; letter-spacing: 0.1em; }
              .flat-box { fill: #081026; stroke: #0F2042; stroke-width: 2; }
              .flat-text { font-family: 'Crimson Pro', serif; font-size: 24px; fill: #6E7D95; font-weight: 700; }
              
              /* Animations */
              .node { animation: pulse 3s infinite ease-in-out; }
              .connection { stroke-dasharray: 5; animation: flow 20s linear infinite; }
              
              @keyframes pulse {
                0% { opacity: 0.6; r: 10; }
                50% { opacity: 1; r: 12; }
                100% { opacity: 0.6; r: 10; }
              }
              @keyframes flow {
                to { stroke-dashoffset: -100; }
              }
            `}
          </style>
        </defs>
        
        {/* Left: Ecosystem Network */}
        <g transform="translate(50, 50)">
          {/* Connection lines first (behind nodes) */}
          <line className="connection" x1="100" y1="100" x2="50" y2="50"/>
          <line className="connection" x1="100" y1="100" x2="150" y2="40"/>
          <line className="connection" x1="100" y1="100" x2="170" y2="120"/>
          <line className="connection" x1="100" y1="100" x2="130" y2="180"/>
          <line className="connection" x1="100" y1="100" x2="30" y2="150"/>
          {/* Cross-connections */}
          <line className="connection" x1="50" y1="50" x2="150" y2="40"/>
          <line className="connection" x1="170" y1="120" x2="130" y2="180"/>
          <line className="connection" x1="30" y1="150" x2="130" y2="180"/>
          <line className="connection" x1="50" y1="50" x2="30" y2="150"/>
          
          {/* Nodes */}
          <circle className="node" cx="100" cy="100" r="15" fillOpacity="0.8"/>
          <circle className="node" cx="50" cy="50" r="8"/>
          <circle className="node" cx="150" cy="40" r="8"/>
          <circle className="node" cx="170" cy="120" r="8"/>
          <circle className="node" cx="130" cy="180" r="8"/>
          <circle className="node" cx="30" cy="150" r="8"/>
          
          {/* Labels */}
          <text className="node-label" x="5" y="30">Storm Protection</text>
          <text className="node-label" x="155" y="30">Fisheries Nursery</text>
          <text className="node-label" x="180" y="115">Trophic Links</text>
          <text className="node-label" x="140" y="200">Water Filtration</text>
          <text className="node-label" x="-10" y="170">Carbon Storage</text>
        </g>
        
        {/* Center: Arrow */}
        <g transform="translate(320, 100)">
          <text className="arrow-label" x="60" y="-15" textAnchor="middle">FLATTENING</text>
          <polygon className="arrow" points="0,30 120,30 120,15 160,50 120,85 120,70 0,70" opacity="0.8"/>
        </g>
        
        {/* Right: Flattened Output */}
        <g transform="translate(550, 60)">
          <rect className="flat-box" x="0" y="0" width="180" height="120" rx="4"/>
          <text className="flat-text" x="90" y="55" textAnchor="middle">1 Tonne</text>
          <text className="flat-text" x="90" y="85" textAnchor="middle">CO₂e</text>
        </g>
      </svg>
    </div>
  );
};

export default FlatteningIllustration;
